import React, { useContext, createContext, useState, type FC, type ReactNode } from 'react';

export type ArtistContextType = {
  artist: string;
}

export const ArtistContext = createContext<ArtistContextType | undefined>(undefined);
export const SetArtistContext = createContext<((artist: string) => void) | undefined>(undefined);

export const ArtistProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [artist, setArtist] = useState<string>('');

  return (
    <ArtistContext.Provider value={{
      artist,
    }}>
      <SetArtistContext.Provider value={setArtist}>
        {children}
      </SetArtistContext.Provider>
    </ArtistContext.Provider>
  );
};

export const useArtist = (): ArtistContextType => {
  const context = useContext(ArtistContext);
  if (context === undefined) {
    throw new Error('useArtistContext must be used within an ArtistProvider');
  }
  return context;
};

export const useSetArtist = (): (artist: string) => void => {
  const ctx = useContext(SetArtistContext);
  if (ctx === undefined) {
throw new Error('useSetArtist must be used within an ArtistProvider');
}
  return ctx;
};
